import React, { useRef, useEffect, useCallback } from 'react';
import { useViewport } from 'hooks/3catinfo/useViewport';
import styles from './modalSnackbar.module.scss';
import Icona from '../../ui/Icona/Icona';
import clsx from 'clsx';
import Enllac from 'components/3catinfo/Enllac';

const ELM_TRES_CATINFO = <span>El meu 3CatInfo</span>;


const textSnackBar = (tipologia, text, afegit) => {
                
  switch (tipologia) {
    case 'NOT_NOTICIA':
      return afegit
          ? 
          <>
              La notícia s&#39;ha guardat. La pots llegir quan vulguis a <Enllac href="/3catinfo/meu3catinfo/noticies/" className={styles.home3catinfo}>{ELM_TRES_CATINFO}</Enllac>
          </>
          : 
          <>
              La notícia s&#39;ha eliminat. 
              Totes les notícies que et guardis les tens a <Enllac href="/3catinfo/meu3catinfo/noticies" className={styles.home3catinfo}>{ELM_TRES_CATINFO}</Enllac>
          </>;

    case 'NOT_AUTOR':
      return afegit
          ? (
              <>
                  Has començat a seguir <span className={styles.bold_text}>{text}</span>.
                  Consulta els seus articles a <Enllac href="/3catinfo/meu3catinfo/firmes/" className={styles.home3catinfo}>{ELM_TRES_CATINFO}</Enllac>
              </>
          )
          : (
              <>
                  Has deixat de seguir <span className={styles.bold_text}>{text}</span>. 
                  Torna a seguir aquesta firma si vols consultar els seus articles a <Enllac href="/3catinfo/meu3catinfo/firmes/" className={styles.home3catinfo}>{ELM_TRES_CATINFO}</Enllac>
              </>
          );

    default:
      return afegit
          ? (
              <>
                  Has començat a seguir <span className={styles.bold_text}>{text}</span>.
                  Consulta més notícies d’aquest tema a <Enllac href="/3catinfo/meu3catinfo/" className={styles.home3catinfo}>{ELM_TRES_CATINFO}</Enllac>
              </>
          )
          : (
              <>
                  Has deixat de seguir <span className={styles.bold_text}>{text}</span>.
                  Torna&#39;l a seguir si vols consultar les notícies d&#39;aquest tema a <Enllac href="/3catinfo/meu3catinfo/" className={styles.home3catinfo}>{ELM_TRES_CATINFO}</Enllac>
              </>
          );
      }

    };

const ModalSnackbar = ({ onClickClose, isVisibleModal, text, tipologia, afegit }) => {
  const modalContentRef = useRef(null);
  const initialFocusRef = useRef(null);
  const touchStartYRef = useRef(0);
  
  const { zoomNavigator } = useViewport();

  const stylesWrapper = clsx({
    [styles.modal_wrapper]: true,
    [styles.visible]: isVisibleModal,
    [styles.ambZoom]: zoomNavigator > 3
  });

  const handleTouchStart = useCallback((e) => {
    touchStartYRef.current = e.targetTouches[0].clientY;
  }, []);

  const handleTouchMove = useCallback((e) => {
    const touchEndY = e.targetTouches[0].clientY;
    const swipeDistance = touchStartYRef.current - touchEndY;
    
    if (swipeDistance > 50) {
      onClickClose();
    }
  }, [onClickClose]);

  const handleClickOutside = useCallback((e) => {
    if (e.target === e.currentTarget || e.target.dataset.testId === 'tancar_snackbar') {
      onClickClose();
    }
  }, [onClickClose]);

  useEffect(() => {
    if (isVisibleModal && initialFocusRef.current) {
      initialFocusRef.current.focus();
    }
  }, [isVisibleModal]);

  useEffect(() => {
    if (!isVisibleModal) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClickClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isVisibleModal, onClickClose]);

  return (
    <>
      <div className={styles.outside} onClick={onClickClose} />
      <div className={styles.modal_mask} onClick={handleClickOutside}>
        <div className={stylesWrapper} data-testid="snackbar">
          <div className={styles.modal_content} ref={modalContentRef}>
            <div
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
            />
            <div className={styles.text_login_centered}>
              <div className={styles.modal_text}>
                {
                  textSnackBar(tipologia, text, afegit)
                }
              </div>
              <div className={styles.button_container}>
                <button
                  onClick={onClickClose}
                  className={styles.tancar}
                  ref={initialFocusRef}
                  data-testid="tancar_snackbar"
                  aria-label="Tancar"
                >
                  <Icona
                    className={styles.iconaTancar}
                    icona="tanca"
                    alt="tanca"
                    mida="32"
                    isBlanc={true}
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalSnackbar;